import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE, FILE_BASE } from "../config";
import "./Checkout.css";


export default function Checkoutinfo() {

  const token = sessionStorage.getItem("token");

  const [cartItems, setCartItems] = useState([]);

  const [paymentMethod, setPaymentMethod] =
    useState("razorpay");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    pincode: "",
    streetAddress: "",
    contactNumber: "",
    email: "",
    additionalInfo: "",
  });

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {

      const response = await axios.get(
        `${API_BASE}/cart`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCartItems(response.data);

    } catch (error) {
      console.error(error);
    }
  };

  const total = cartItems.reduce(
    (sum, item) => sum + item.subtotal,
    0
  );

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const loadRazorpay = () => {
    return new Promise((resolve) => {

      const script = document.createElement("script");

      script.src =
        "https://checkout.razorpay.com/v1/checkout.js";

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => {
        resolve(false);
      };

      document.body.appendChild(script);
    });
  };

  const placeOrder = async () => {

    try {

      const loaded = await loadRazorpay();

      if (!loaded) {
        alert("Razorpay SDK failed");
        return;
      }

      // ✅ CREATE ORDER
      const orderResponse = await axios.post(
        `${API_BASE}/order/create-razorpay-order`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const razorpayOrder = orderResponse.data;

      const options = {
        key: "rzp_test_SpAABX9cL2aiwB",

        amount: razorpayOrder.amount * 100,

        currency: "INR",

        name: "SaPra",

        description: "Order Payment",

        order_id: razorpayOrder.orderId,

        method: {
          upi: true,
          card: true,
          netbanking: true,
          wallet: true,
        },

        config: {
          display: {
            blocks: {
              upi: {
                name: "Pay using UPI",
                instruments: [
                  {
                    method: "upi"
                  }
                ]
              }
            },

            sequence: ["block.upi"],

            preferences: {
              show_default_blocks: true
            }
          }
        },

        handler: async function (response) {

          try {

            const checkoutDto = {
              firstName: formData.firstName,
              lastName: formData.lastName,
              companyName: formData.companyName,
              pincode: formData.pincode,
              streetAddress: formData.streetAddress,
              contactNumber: formData.contactNumber,
              email: formData.email,
              additionalInfo:
                formData.additionalInfo,
            };

            // ✅ PLACE ORDER
            const placeOrderResponse =
              await axios.post(
                `${API_BASE}/order/place-order`,
                checkoutDto,
                {
                  params: {
                    razorpayPaymentId:
                      response.razorpay_payment_id,

                    razorpayOrderId:
                      response.razorpay_order_id,

                    signature:
                      response.razorpay_signature,
                  },

                  headers: {
                    Authorization:
                      `Bearer ${token}`,
                  },
                }
              );

            console.log(
              placeOrderResponse.data
            );

            alert("Order placed successfully");

            window.location.href = "/shop";

          } catch (error) {

            console.error(error);

            console.log(error.response);

            alert(
              error?.response?.data ||
              error.message
            );
          }
        },

        prefill: {
          name:
            `${formData.firstName} ${formData.lastName}`,

          email: formData.email,

          contact: formData.contactNumber,
        },

        theme: {
          color: "#000000",
        },
      };

      const paymentObject =
        new window.Razorpay(options);

      paymentObject.open();

    } catch (error) {

      console.error(error);

      alert("Something went wrong");
    }
  };

  return (
    <div className="checkout-container">

      <div className="checkout-left">

        <h2>Billing details</h2>

        <div className="row">

          <div className="field">
            <label>First Name</label>

            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Last Name</label>

            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="field">
          <label>Company Name</label>

          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>PIN code</label>

          <input
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Street address</label>

          <input
            type="text"
            name="streetAddress"
            value={formData.streetAddress}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Contact Number</label>

          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Email</label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className="field">

          <textarea
            name="additionalInfo"
            placeholder="Additional Information"
            value={formData.additionalInfo}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="checkout-right">

        <div className="summary-row-header">
          <span>Product</span>
          <span>Subtotal</span>
        </div>

        {cartItems.map((item) => (

          <div
            className="summary-row"
            key={item.productId}
          >
            <span>
              {item.productName} x {item.quantity}
            </span>

            <span>
              Rs. {item.subtotal}
            </span>
          </div>
        ))}

        <div className="summary-row">
          <span>Subtotal</span>

          <span>Rs. {total}</span>
        </div>

        <div className="summary-total">
          <span>Total</span>

          <span>Rs. {total}</span>
        </div>

        <div className="payment">

          <label>
            <input
              type="radio"
              checked={
                paymentMethod === "razorpay"
              }
              onChange={() =>
                setPaymentMethod("razorpay")
              }
            />

            Razorpay
          </label>
        </div>

        <button
          className="order-btn"
          onClick={placeOrder}
        >
          Place Order
        </button>

      </div>
    </div>
  );
}